// extracted by mini-css-extract-plugin
export default {"header":"header_header__A7NEZ","content":"header_content__xTFDe"};